export default {
  component: () => import('./page.vue'),
  path: '/audit/:id',
  name: 'audit',
  meta: {
    title: '待处理',
    auth: true,
  },
};
